import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import moment from 'moment';
import { DatePicker } from '@ionic-native/date-picker';
import { EventsProvider } from '../../providers/events/events';
import { ConfigProvider } from '../../providers/config/config';
import { Platform } from 'ionic-angular/platform/platform';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { NavController, ModalController, PopoverController, Events, LoadingController } from 'ionic-angular';
import { AppState } from '../../config/state';
import { FilteringProvider } from '../../providers/filtering/filtering';
import { IMyDrpOptions } from 'mydaterangepicker';
import { CoCalendarComponent } from '../co-calendar/co-calendar';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
/**
 * Generated class for the CoEventsRangeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-range',
  templateUrl: 'co-events-range.html',
  inputs: ['popOverFilter', 'currentDate']
})
export class CoEventsRangeComponent {
  @ViewChild(CoCalendarComponent) innerCalendar: CoCalendarComponent;
  //date variables
  fromDate: any;
  toDate: any;
  fromDateElement: any;
  toDateElement: any;
  calendarLine: Array<string> = [];
  @Input('currentDate') currentDate;
  @Input('popOverFilter') popOverFilter: any;
  @Output() currentDensityForFilters: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventQueryTimeArgs: EventEmitter<any> = new EventEmitter<any>();
  @Output() keywordSearchEmit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('eventView') eventView;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
  //event variables
  eventsList: any;
  unfilteredEventsList: any;
  filteredEventsList: any;
  searchTags: any;
  density3Array: any;
  lastEventTime: any;
  clientKeyword: string;
  showKeywordBox: boolean = false;
  searchForKeyword: string = "";
  //page variables
  currentDensity: number;
  pageLoaded: boolean = false;
  viewType: string;
  rangeInfo: any;
  screenWidth: any = this.platform.width();
  aboveWidthBreakpoint: boolean;
  rangeButtonType: boolean;
  loading: any;
  desktopRangeSelection: { start: string, end: string } = { start: "", end: "" };
  eventsArray: any;
  myDateRangePickerOptionsMobile: IMyDrpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    firstDayOfWeek: 'su',
    sunHighlight: false,
    markCurrentDay: true,
    selectorHeight: '40vh',
    selectorWidth: '90vw',
    height: '48px',
    width: '100px',
    selectionTxtFontSize: '18px',
    showClearBtn: false,
    showApplyBtn: false,
    inline: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true
  };
  myDateRangePickerOptions: IMyDrpOptions = {
    // other options...
    dateFormat: 'mm/dd/yyyy',
    firstDayOfWeek: 'su',
    sunHighlight: false,
    markCurrentDay: true,
    selectorHeight: '450px',
    selectorWidth: '500px',
    height: '48px',
    width: '100px',
    selectionTxtFontSize: '18px',
    showClearBtn: false,
    showApplyBtn: false,
    inline: false,
    editableDateRangeField: false,
    openSelectorOnInputClick: true
  }; //EDITABLE DATE RANGE FIELD AND OPEN SELECTOR ON INPUT CLICK DO NOT WORK
  constructor(private datePicker: DatePicker, public eventsProvider: EventsProvider, public config: ConfigProvider, private platform: Platform, private clientDetails: ClientDetailsProvider, public navCtrl: NavController, public state: AppState, public modalCtrl: ModalController, public popoverCtrl: PopoverController, public filteringProvider: FilteringProvider, private events: Events, private loader: LoadingController) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = self.state.mode;
      self.rangeButtonType = self.state.cordovaAvailable;
      self.screenWidth = self.platform.width();
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
  }
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
  }

  ngOnInit() {
    this.monthClicked(this.currentDate);
  }

  ngAfterViewInit() {
    // if (this.state.mode != 'desktop') {
    //   this.fromDateElement = document.getElementById("fromText");
    //   this.toDateElement = document.getElementById("toText");
    //   this.fromDate = moment(this.currentDate).format("MM/DD/YYYY");
    //   this.toDate = moment(this.currentDate).format("MM/DD/YYYY");
    //   this.fromDateElement.innerHTML = this.fromDate;
    //   this.toDateElement.innerHTML = this.toDate;
    // }
    // this.monthClicked(this.currentDate);
    // this.pickDate();
    // let queryEventsArgs = `startDate: "${moment(this.fromDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.toDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    // this.queryEvents(queryEventsArgs);
  }

  pickDate() {
    // let eventArgs = `startDate: ${moment().year(this.rangeInfo.beginDate.year).}`
    let startDate, endDate;
    if (this.rangeInfo){
      startDate = moment(`${this.rangeInfo.beginDate.year}-${this.rangeInfo.beginDate.month}-${this.rangeInfo.beginDate.day}`).startOf('day').format("YYYY-MM-DD HH:mm:ss");
      endDate = moment(`${this.rangeInfo.endDate.year}-${this.rangeInfo.endDate.month}-${this.rangeInfo.endDate.day}`).endOf('day').format("YYYY-MM-DD HH:mm:ss");
    } else {
      startDate = moment().startOf('day').format("YYYY-MM-DD HH:mm:ss");
      endDate = moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
    }
    this.monthClicked(this.currentDate);
    // let queryArgs = `startDate: "${startDate}", endDate: "${endDate}"`;
    // this.queryEvents(queryArgs);
  }

  resetRangeView(newDate) {
    this.fromDate = moment(newDate).format("MM/DD/YYYY");
    this.toDate = moment(newDate).format("MM/DD/YYYY");
    // this.fromDateElement.innerHTML = this.fromDate;
    // this.toDateElement.innerHTML = this.toDate;
    let queryEventsArgs = `startDate: "${moment(this.fromDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.toDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(queryEventsArgs);
  }

  updateKeywordFilter() {
    if (this.searchForKeyword.length > 0) this.keywordSearchEmit.emit({ keyword: this.searchForKeyword })
  }

  cancelKeywordFilter(){
    this.keywordSearchEmit.emit({keyword: ''})
  }

  updateBrochureStartDay(start, end) {
    this.eventQueryTimeArgs.emit({ start: moment(start).format("YYYY-MM-DD HH:mm:ss"), end: moment(end).format("YYYY-MM-DD HH:mm:ss") })
  }

  inputDate(event, range) {
    // console.log('weijlrkj', event, range)
    this.desktopRangeSelection[range] = event.value;

    if (this.desktopRangeSelection.start != "" && this.desktopRangeSelection.end != "") {
      if (moment(this.desktopRangeSelection.start).isBefore(this.desktopRangeSelection.end)) {
        let eventArgs = `startDate: "${moment(this.desktopRangeSelection.start).startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.desktopRangeSelection.end).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`
        this.queryEvents(eventArgs);
      }
    }
  }

  // callDatePicker(element) {
  //   let startingDisplayDate, minDate, maxDate;

  //   if (element == 'from') {
  //     startingDisplayDate = moment(this.fromDate);
  //     minDate = moment();
  //     this.toDate? maxDate = moment(this.toDate) : maxDate = "";
  //   }
  //   else {
  //     startingDisplayDate = moment(this.toDate);
  //     minDate = moment(this.fromDate);
  //     maxDate = '';
  //   }

  //   this.datePicker.show({
  //     date: startingDisplayDate,
  //     minDate: minDate,
  //     maxDate: maxDate,
  //     mode: 'date',
  //     androidTheme: this.datePicker.ANDROID_THEMES.THEME_HOLO_DARK
  //   }).then( date => {
  //     // console.log(date);
  //       if (element == 'from') {
  //         this.fromDate = moment(date).format("MM/DD/YYYY");
  //         let queryEventsArgs = `startDate: "${moment(this.fromDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.toDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
  //         if (this.fromDate && this.toDate){
  //           this.queryEvents(queryEventsArgs);
  //         }
  //       } else {
  //         this.toDate = moment(date).format("MM/DD/YYYY");
  //         let queryEventsArgs = `startDate: "${moment(this.fromDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.toDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
  //         if (this.fromDate && this.toDate){
  //           this.queryEvents(queryEventsArgs);
  //         }
  //       }
  //     },
  //     err => console.log('Error occurred while getting date: ', err)
  //   );
  //   window.scroll(0,0);
  // }

  queryEvents(args) {
    this.loading = this.loader.create({ content: "Searching for events..." });
    this.loading.present();
    this.eventsProvider.getEvents(args).then((res) => {
      let unfilteredEventsList = res.allEvents;
      this.events.subscribe('updateAllEvents', async () => {
        unfilteredEventsList = await this.eventsProvider.checkInterestedEvents(res);
      });
      this.unfilteredEventsList = unfilteredEventsList;
      this.eventsList = unfilteredEventsList;
      this.searchTags = res.searchTypes;
      this.pageLoaded = true;
      if (this.fromDate) {
        if (this.fromDate && this.toDate) {
          this.updateBrochureStartDay(this.fromDate, this.toDate);
        } else {
          this.updateBrochureStartDay(moment().startOf('day'), moment().endOf('day'));
        }
      } else if (this.rangeInfo) {
        this.updateBrochureStartDay(`${this.rangeInfo.beginDate.month}/${this.rangeInfo.beginDate.day}/${this.rangeInfo.beginDate.year}`, `${this.rangeInfo.endDate.month}/${this.rangeInfo.endDate.day}/${this.rangeInfo.endDate.year}`)
      } else {
        if (this.desktopRangeSelection.start && this.desktopRangeSelection.end) {
          this.updateBrochureStartDay(this.desktopRangeSelection.start, this.desktopRangeSelection.end);
        } else {
          this.updateBrochureStartDay(moment().startOf('day'), moment().endOf('day'));
        }
      }
      // res.allEvents.length>0? this.eventsCheck = true : this.eventsCheck = false;

      let filteredEventsObject = this.unfilteredEventsList.reduce((red, event) => {
        let currentEventTime = moment(event.eventStart).format("YYYY-DDD");
        if (!red[currentEventTime]) {
          red[currentEventTime] = [];
        }
        red[currentEventTime].push(event);
        return red;
      }, {});

      //Set initial density object seperated by the hour of the day
      let density3ObjectInitial = this.unfilteredEventsList.reduce((red, event) => {
        let currentEventTime = moment(event.eventStart).format("YYYY-DDD HH");
        if (!red[currentEventTime]) red[currentEventTime] = [];
        red[currentEventTime].push(event);
        return red;
      }, {});

      //turn that object into an array
      let newDensity3Array = Object.keys(density3ObjectInitial).map((key) => {
        return density3ObjectInitial[key];
      });

      //Reduce that array into an object seperated by day instead of hours
      let density3ObjectByDay = newDensity3Array.reduce((red, event) => {
        let currentEventTime = moment(event[0].eventStart).format("YYYY-DDD");
        if (!red[currentEventTime]) red[currentEventTime] = [];
        red[currentEventTime].push(event);
        return red;
      }, {});

      this.filteredEventsList = Object.keys(filteredEventsObject).map((key) => {
        return filteredEventsObject[key];
      });

      //Turn that object into an array to be read by the ngFor
      this.density3Array = Object.keys(density3ObjectByDay).map((key) => {
        return density3ObjectByDay[key];
      });
      this.filterByPopOver(this.popOverFilter);
    })
  };

  createArrayForPage(filterArray) {
    let filteredEventsObject;
    filteredEventsObject = filterArray.reduce((red, event) => {
      let currentEventTime = moment(event.eventStart).format("YYYY-DDD");
      if (!red[currentEventTime]) {
        red[currentEventTime] = [];
      }
      red[currentEventTime].push(event);
      return red;
    }, {});

    // this.filteredEventsList = Object.keys(filteredEventsObject).map((key) => {
    //   return filteredEventsObject[key];
    // });
    this.eventsArray = filterArray;
    this.loading.dismiss().catch(err=>{});
  };

  filterByPopOver(filterObj) {
    this.filteringProvider.filterByPopover(filterObj, this.eventsList).then((res) => {
      this.createArrayForPage(res);
    })
  }

  updateDensity(density: number) {
    let className = "density" + density.toString();
    // let allEventViews = document.getElementsByClassName('eventView');
    let allEventViews = this.eventView.nativeElement;
    allEventViews.className = (className + " eventView");
    this.currentDensity = density;
    this.currentDensityForFilters.emit(density);
    if (this.pageLoaded && this.virtualScroller){
      this.virtualScroller.scrollToPosition(0, 100);
    }
  }

  checkLastDate(eventTime: string) {
    //if no last event
    if (this.lastEventTime == '') {
      this.lastEventTime = eventTime;
      return true;
    }

    //if they are the same, skip the day header
    if (moment(eventTime).day() == moment(this.lastEventTime).day()) {
      return false;
    }

    //if not, render the new day of week
    this.lastEventTime = eventTime;
    return true;
  }

  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    } else {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }

  screenWidthAboveBP() {
    if (this.platform.width() > 992) {
      return true;
    } else {
      return false;
    };
  };


  //calendar implementation
  calendarLoad(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).startOf('month').add(x, 'month').format("YYYY-MM-DD HH:mm:ss"))
    };
  };

  previousMonths(date: string) {
    let selectedDate = moment(date).startOf('month').subtract(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  nextMonths(date: string) {
    let selectedDate = moment(date).startOf('month').add(5, 'month').format("YYYY-MM-DD HH:mm:ss");

    this.calendarLine = [];
    for (let x = 0; x < 5; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'month').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(2, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.monthClicked(selectedDate);
  }

  monthClicked(dateString: string) {
    let startDate = moment(dateString).startOf('day').format("YYYY-MM-DD");
    let endDate = moment(dateString).endOf('day').format("YYYY-MM-DD");
    // let newMonthQuery = `startDate: "${startDate}", endDate: "${endDate}"`;
    // this.queryEvents(newMonthQuery);
    this.innerCalendar.goToMonth(dateString);
    // this.innerCalendar.loadMonthEvents(this.monthEvents);
    // this.updateEvents(moment(dateString)); Already being done by this.queryEvents(newMonthQuery);
    this.calendarLoad(dateString);
    this.eventQueryTimeArgs.emit({ start: moment(startDate).format("YYYY-MM-DD HH:mm:ss"), end: moment(endDate).format("YYYY-MM-DD HH:mm:ss") });
  }

  updateEvents(event) {
      // let startDate = event.fromDate.format("YYYY-MM-DD");
      // let endDate = event.toDate.format("YYYY-MM-DD");
      let startDate, endDate;
      // console.log(event);
      event.fromDate? startDate = event.fromDate.format("YYYY-MM-DD") : startDate = moment().format("YYYY-MM-DD");
      event.toDate? endDate = event.toDate.format("YYYY-MM-DD") : endDate = moment().format("YYYY-MM-DD");
      this.fromDate = startDate;
      this.toDate = endDate;
      if (!event.toDate) {
        this.toDate = '';
        return;
      }
      let newMonthQuery = `startDate: "${startDate}", endDate: "${endDate}"`;
      this.queryEvents(newMonthQuery);
      this.eventQueryTimeArgs.emit({ start: event.fromDate.format("YYYY-MM-DD 00:00:00"), end: event.toDate.endOf('day').format("YYYY-MM-DD HH:mm:ss") });
  }
}



// WEBPACK FOOTER //
// ./src/components/co-events-range/co-events-range.ts